import { render, staticRenderFns } from "./doublechancelotto.vue?vue&type=template&id=7ab29980"
import script from "./doublechancelotto.vue?vue&type=script&lang=js"
export * from "./doublechancelotto.vue?vue&type=script&lang=js"
import style0 from "./doublechancelotto.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/doublechancelotto.vue
// module id = 6y0s
// module chunks = 0